// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-74a3c0d2]{position:relative;border:.1rem solid #fc797e;padding-top:.3rem;border-radius:50%;font-size:3rem;background-color:#fff}button .icon[data-v-74a3c0d2]{color:#fc797e;z-index:2}.animation[data-v-74a3c0d2]{position:absolute;left:0;top:0;width:100%;height:100%;z-index:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
